import React, { useEffect, useState } from 'react';
import { Users, CheckCircle, Clock, DollarSign, X } from 'lucide-react';
import axios from 'axios';

export default function StatsCards({ bookings }) {
  const total = bookings.length;
  const confirmed = bookings.filter(b => b.status === 'مؤكد').length;
  const pending = bookings.filter(b => b.status === 'قيد الانتظار').length;
  const revenue = bookings.filter(b => b.status !== 'ملغي').reduce((a, b) => a + b.price, 0);
  const cancelled = bookings.filter(b => b.status === 'ملغي').length;


    const [shownData , setShownData] = useState([
      {
        name : "" ,
        phone : "" ,
        email : "" ,
        service : "" ,
        date : "" ,
        status : "" ,
  
      }
    ])

//     useEffect(() => {
//     axios.get("https://dr-mohamed-khaled.site/api/patients")
// .then((response) => { 
// setShownData(response?.data?.patients || [])
//  })

//  console.log(shownData)
//  } 
// , [])


useEffect(() => {
  const fetchData = () => {
    axios.get("https://dr-mohamed-khaled.site/api/patients")
      .then((response) => {
        setShownData(response?.data?.patients || []);
      });
  };

  fetchData(); // أول load
  const interval = setInterval(fetchData, 2000); // كل 5 ثواني

  return () => clearInterval(interval); // cleanup
}, []);

const stats = [
  {
    label: 'إجمالي الحجوزات',
    value: shownData.length,
    icon: Users,
    color: '#3b82f6',
    bg: 'rgba(59,130,246,0.1)',
  },
  {
    label: 'المؤكدة',
    value: shownData.filter(b => b.status === 'complete').length,
    icon: CheckCircle,
    color: '#22c55e',
    bg: 'rgba(34,197,94,0.1)',
  },
  {
    label: 'قيد الانتظار',
    value: shownData.filter(b => b.status === 'pending').length,
    icon: Clock,
    color: '#f59e0b',
    bg: 'rgba(245,158,11,0.1)',
  },
];
  return (
    <div className="stats-grid">
      {stats.map((stat, i) => (
        <div key={i} className="stat-card" style={{ animationDelay: `${i * 0.1}s` }}>
          <div className="stat-icon" style={{ background: stat.bg, color: stat.color }}>
            <stat.icon size={22} />
          </div>
          <div className="stat-info">
            <span className="stat-value" style={{ color: stat.color }}>{stat.value}</span>
            <span className="stat-label">{stat.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
